// Finance build (Workstream E) — HTTP transport for the cross-loan Loan
// Payments ledger: real recorded servicing payments across all loans, each
// with its waterfall split summary + per-payment income variance. Read-only
// over the v3 payment ledger. Hooks in @/hooks/portfolioAdmin/useLoanPayments
// wrap this with TanStack Query.

import { api } from "@/api/client";

export interface LoanPaymentRowDto {
  paymentId: string;
  loanId: string | null;
  loanNumber: string | null;
  paymentDate: string;
  paymentType: string;
  status: string;
  amount: number;
  disbursementCount: number;
  totalDistributed: number;
  expectedIncome: number;
  receivedIncome: number;
  incomeVariance: number;
  // Pay-ahead lineage — set when this row is a pay-ahead child advanced from a
  // larger recorded payment on the same loan; the ledger links back to it. Older
  // payloads omit it (optional).
  paidAheadFromPaymentId?: string | null;
}

export interface LoanPaymentsLedgerSummaryDto {
  count: number;
  totalAmount: number;
  totalDistributed: number;
  totalExpectedIncome: number;
  totalReceivedIncome: number;
}

export interface LoanPaymentsLedgerDto {
  rows: LoanPaymentRowDto[];
  summary: LoanPaymentsLedgerSummaryDto;
}

export interface LoanPaymentsLedgerParams {
  loanId?: string;
  status?: string;
  from?: string;
  to?: string;
}

export const loanPaymentsApi = {
  ledger: (params?: LoanPaymentsLedgerParams) =>
    api.get<LoanPaymentsLedgerDto>(`/portfolio-admin/loan-payments`, params),
};
